var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 41,
    viewBox: "0 0 65 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_4582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 40.2031C50.1731 40.2031 64.5 37.0923 64.5 33.255C64.5 29.4177 50.1731 26.307 32.5 26.307C14.8269 26.307 0.5 29.4177 0.5 33.255C0.5 37.0923 14.8269 40.2031 32.5 40.2031Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5 14.1653L45.354 2.74866C44.867 1.97048 44.156 1.5 43.407 1.5H21.593C20.844 1.5 20.133 1.97048 19.646 2.74767L9.5 14.1663V23.3367H55.5V14.1653Z",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.113 17.3128C42.113 15.7197 43.107 14.4046 44.34 14.4036H55.5V32.4059C55.5 34.5132 54.18 36.2402 52.55 36.2402H12.45C10.82 36.2402 9.5 34.5122 9.5 32.4059V14.4036H20.66C21.893 14.4036 22.887 15.7167 22.887 17.3098V17.3317C22.887 18.9248 23.892 20.2111 25.124 20.2111H39.876C41.108 20.2111 42.113 18.9128 42.113 17.3198V17.3128V17.3128Z",
    fill: "#FAFAFA",
    stroke: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_4582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 40,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.17631f2b88ee450e8b1174d3748333f6.svg";
export { ForwardRef as ReactComponent };